// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SupportedUnitCodes } from "./SupportedUnitCodes";
import {
  SupportedUnitCodesFromJSON,
  SupportedUnitCodesFromJSONTyped,
  SupportedUnitCodesToJSON,
  SupportedUnitCodesToJSONTyped,
} from "./SupportedUnitCodes";

/**
 * The UCUM code for the unit
 * @export
 * @interface Code
 */
export interface Code {}

/**
 * Check if a given object implements the Code interface.
 */
export function instanceOfCode(value: object): value is Code {
  return true;
}

export function CodeFromJSON(json: any): Code {
  return CodeFromJSONTyped(json, false);
}

export function CodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Code {
  return json;
}

export function CodeToJSON(json: any): Code {
  return CodeToJSONTyped(json, false);
}

export function CodeToJSONTyped(value?: Code | null, ignoreDiscriminator: boolean = false): any {
  return value;
}
